// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/list","root":"list-m__root__SEwTU","items":"list-m__items__1mYDz","divider":"list-m__divider__3aqPc"};